import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-time-report-modal',
  templateUrl: './time-report.component.html',
  styleUrls: ['../modal.component.scss']
})

export class TimeReportModalComponent {
  @Input() title!: string;
  @Input() isDateRangeOptional: boolean = false;
  @Output() readonly responseChanged = new EventEmitter<{ fromDate: Date; toDate: Date } | null>();
  fromDate!: Date;
  toDate!: Date;

  constructor() {}

  emitTrue(): void {
    this.responseChanged.emit({ fromDate: this.fromDate, toDate: this.toDate });
  }

  emitFalse(): void {
    this.responseChanged.emit(null);
  }
}